import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Badge } from './ui/badge';
import { Users, Plus } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Reusable Role Selector with color-coded badges
 * Used across: AddTeamModal, TeamMembersTab, AssetsTab
 */
const RoleSelector = ({ 
  roles = [], 
  value, 
  onChange, 
  placeholder = "Select a role...",
  showAddButton = true,
  onAddClick,
  disabled = false,
  className = ""
}) => {
  const handleValueChange = (val) => {
    if (val === '__add_new__') {
      if (onAddClick) {
        onAddClick();
      } else {
        // Navigate to roles page
        window.dispatchEvent(new CustomEvent('navigate', { detail: 'roles' }));
      }
    } else {
      onChange(val);
    }
  };

  return (
    <Select value={value} onValueChange={handleValueChange} disabled={disabled}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {roles.length === 0 ? (
          <div className="px-2 py-4 text-sm text-gray-500 text-center">
            No roles available
          </div>
        ) : (
          roles.map((role) => (
            <SelectItem key={role.id} value={role.id}>
              <div className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-full flex-shrink-0" 
                  style={{ backgroundColor: role.color || '#3B82F6' }}
                />
                <span className="font-medium">{role.name}</span>
                {role.description && (
                  <span className="text-xs text-gray-500">- {role.description}</span>
                )}
              </div>
            </SelectItem>
          ))
        )}
        {showAddButton && (
          <SelectItem 
            value="__add_new__" 
            className="text-blue-600 font-semibold border-t mt-1 pt-2"
          >
            + Add Role
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};

export default RoleSelector;
